module.exports = __webpack_public_path__ + "img/DSC_2859.67f4973e.png";